import { Container } from './styles'

type DialogProps = {
  children: JSX.Element
}

export const Dialog = ({ children }: DialogProps) => {
  return (
    <Container>
      <div className="content">{children}</div>
    </Container>
  )
}
